import React from "react"
import styled from "styled-components"
import MockupWelcome from "../animations/MockupWelcome"

function WelcomeSection() {
  return (
    <Wrapper>
      <ContentWrapper>
        <MockupWelcome />
      </ContentWrapper>
    </Wrapper>
  )
}

export default WelcomeSection

const Wrapper = styled.div`
  background: linear-gradient(180deg, #00cffd 0%, #9076e7 100%);
  overflow: hidden;
`
const ContentWrapper = styled.div`
  max-width: 1234px;
  margin: 10px 10px;
  position: relative;
  top: 200px;
  z-index: 6;
`
